/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_CreateInputs */

const en_admin_categories_create = /** @type {(inputs: Admin_Categories_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Category`)
};

/**
* | output |
* | --- |
* | "Create Category" |
*
* @param {Admin_Categories_CreateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_create = /** @type {((inputs?: Admin_Categories_CreateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_CreateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_create(inputs)
});
export { admin_categories_create as "admin.categories.create" }